export const classes = {
  drawerTitle: {
    margin: '24px 0',
  },
  drawerPaper: {
    height: 'calc(100% - 30px - var(--ion-safe-area-top))',
  },
}
